import { Icon, Typography } from '@smartgift/frontend-toolkit';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import QRCode from 'react-qr-code';

import * as S from './style';

function ShareQR({ link, size }) {
  const { t } = useTranslation();
  const svgRef = useRef(null);
  const [focused, setFocused] = useState(false);

  const handlePngDownload = e => {
    e.stopPropagation();
    const canvas = document.createElement('canvas');
    const svgString = svgRef.current.innerHTML;
    const img = new Image();
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      canvas.getContext('2d').drawImage(img, 0, 0);
      const pngURL = canvas.toDataURL('image/png');
      const downloadLink = document.createElement('a');
      downloadLink.download = 'qr-code.png';
      downloadLink.href = pngURL;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    };
    img.src = 'data:image/svg+xml;base64,' + btoa(svgString);
  };

  function handleSvgDownload(e) {
    e.stopPropagation();
    const svgString = svgRef.current.innerHTML;
    const downloadLink = document.createElement('a');
    downloadLink.download = 'qr-code.svg';
    downloadLink.href = 'data:image/svg+xml;base64,' + btoa(svgString);
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }

  function handleDownload(e) {
    handlePngDownload(e);
  }

  function onMouseEnter() {
    setFocused(true);
  }
  function onMouseLeave() {
    setFocused(false);
  }

  return (
    <S.ShareQR onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      {link && (
        <S.ShareQRBox ref={svgRef} style={{ width: size, height: size }}>
          <QRCode size={size * 10} value={link} />
        </S.ShareQRBox>
      )}
      {focused && (
        <S.ShareQRText variant="text" onClick={handleDownload}>
          <S.IconWrapper>
            <Icon name="download" color={'var(--color-neutral-800)'} />
          </S.IconWrapper>
          <Typography variant="body2Bold" emphasis="25" color="neutral">
            {t('download')}
          </Typography>
          <S.ShareQRTextTypes>
            <S.ShareQRTextType onClick={handlePngDownload}>PNG</S.ShareQRTextType>
            <S.ShareQRTextType onClick={handleSvgDownload}>SVG</S.ShareQRTextType>
          </S.ShareQRTextTypes>
        </S.ShareQRText>
      )}
    </S.ShareQR>
  );
}

ShareQR.S = S;

export { ShareQR };
